import { SubSection } from "../../Sitemap/SitemapData"

function normalizePath(path: string): string {
    if (path === "/") {
        return path
    }

    return path.replace(/\/+$/, "")
}

export default function isRouteActive(path: string, route: string, subsections?: SubSection[]): boolean {
    const normalizedPath = normalizePath(path)
    const normalizedRoute = normalizePath(route)

    if (normalizedPath === normalizedRoute) {
        return true
    }

    const match = subsections?.some((subsection) => {
        if (normalizePath(subsection.route) === normalizedPath) {
            return true
        }
        return false
    })

    return match || false
}
